import React from "react";

const ROLES = [
  { value: "admin", label: "Admin (full access)" },
  { value: "manager", label: "Manager (no employee CRUD)" },
  { value: "employee", label: "Employee (own data only)" },
];

/**
 * Add / edit user form.
 */
export default function UserForm({
  form,
  setForm,
  editingId,
  busy,
  err,
  employees,
  onSubmit,
  onCancelEdit,
}) {
  return (
    <form onSubmit={onSubmit}>
      <div className="form-section-title">
        <i className="ti ti-user-plus" style={{ fontSize: 12 }}></i>{" "}
        {editingId ? "Edit User" : "Add New User"}
      </div>
      {err ? (
        <div
          style={{
            background: "#fee2e2",
            color: "#991b1b",
            borderRadius: 6,
            padding: "6px 10px",
            fontSize: 11,
            marginBottom: 10,
          }}
          data-testid="users-error"
        >
          {err}
        </div>
      ) : null}
      <div className="form-row">
        <div className="form-group">
          <label>Email *</label>
          <input
            type="email"
            required
            disabled={!!editingId}
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="user-email-input"
          />
        </div>
        <div className="form-group">
          <label>Full Name</label>
          <input
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid="user-name-input"
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Password {editingId ? "(leave blank to keep)" : "*"}</label>
          <input
            type="password"
            required={!editingId}
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="user-password-input"
          />
        </div>
        <div className="form-group">
          <label>Role *</label>
          <select
            value={form.role}
            onChange={(e) => setForm({ ...form, role: e.target.value })}
            data-testid="user-role-select"
          >
            {ROLES.map((r) => (
              <option key={r.value} value={r.value}>
                {r.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      {form.role === "employee" ? (
        <div className="form-row">
          <div className="form-group" style={{ gridColumn: "1 / -1" }}>
            <label>Linked Employee Record</label>
            <select
              value={form.employee_id}
              onChange={(e) => setForm({ ...form, employee_id: e.target.value })}
              data-testid="user-employee-select"
            >
              <option value="">— None —</option>
              {employees.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.id} — {e.name} ({e.grade})
                </option>
              ))}
            </select>
            <div style={{ fontSize: 10, color: "#666", marginTop: 3 }}>
              Required for an employee to view their own data.
            </div>
          </div>
        </div>
      ) : null}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 6 }}>
        {editingId ? (
          <button
            type="button"
            className="btn"
            onClick={onCancelEdit}
            data-testid="user-cancel-edit-btn"
          >
            Cancel
          </button>
        ) : null}
        <button
          type="submit"
          className="btn btn-primary"
          disabled={busy}
          data-testid="user-save-btn"
        >
          <i className="ti ti-check"></i> {editingId ? "Save changes" : "Create user"}
        </button>
      </div>
    </form>
  );
}
